import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UrlService } from '../url/url.service';
import { Note } from '../../objects/note';
import { File } from '../../objects/file';

@Injectable({
    providedIn: 'root'
})

export class NotesService {

    public addNoteControl:boolean = false;
    public displayNote:boolean = false;

    constructor(public urlSrv: UrlService, public http: HttpClient){}

    // setDisplayNote(data){
    //     this.displayNote = data;
    // }

    // addNote(fileId, data){
    //     return this.http.post(this.urlService.build("/notes/"+fileId+"/add"), data).subscribe(data => {
    //         console.log(data);
    //     });
    // }

    // getNotes(fileId, page){
    //     return this.http.get(this.urlService.build("/notes/"+fileId+"/"+page));
    // }

    // deleteNote(idNote){
    //     return this.http.get(this.urlService.build("/note/"+idNote+"/disable"));
    // }

    find(file: File, urlPrefix: string = "", context: string ="") {
        return this.http.get(this.urlSrv.build(urlPrefix) + "/files/" + file.id + "/notes");
    }

    /**
     * @deprecated no more save legacy notes.
     * 
     */
    save(file: File, notes: Array<Note>, urlPrefix: string = "",context: string = "" ) {

        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};

        return this.http.post(
            this.getContextUrl(urlPrefix,context)+"/files/"+file.id+"/notes", 
            notes, 
            options
        );
    }

    findByMultipleFiles(files: Array<File>, urlPrefix: string = "",context: string = "") {

        let fileIds = files.map((f: File) => f.id).join(',');
        console.debug("joined", fileIds);
        return this.http.get(this.getContextUrl(urlPrefix,context) + "/notes/" + fileIds);
    }

    // remove(note: Note) {
    //     return this.http.delete(this.urlSrv.build("/notes/" + note.id));
    // }

    protected getContextUrl(prefix: string, context:string){
        return (context != "" && context != 'default') ? prefix : this.urlSrv.build(prefix);
    }
}
